import { Component, EventEmitter, OnInit , Output} from '@angular/core';
import { AuthenticationService } from 'app/core/services/auth.service';
import { CompaniesService } from 'app/view/companies/companies.service';

@Component({
  selector: 'app-select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.scss']
})
export class SelectCompanyComponent implements OnInit {

  companies:any[]=[]

  @Output() selectedCompany : EventEmitter<any> = new EventEmitter();

  constructor( private _CompaniesService: CompaniesService,
        public _AuthenticationService: AuthenticationService,
  ) { }

  ngOnInit(): void {
    this._CompaniesService.getAllCompanies().subscribe(res=>{
      this.companies = res.data;
    })
  }

}
